//@flow
/**
 * Client reducer
 * @module client/reducer
 */
import { Record, List } from 'immutable'

export const FETCH_CLIENT_REQUEST = 'FETCH_CLIENT_REQUEST'
export const FETCH_CLIENT_PENDING = 'FETCH_CLIENT_PENDING'
export const FETCH_CLIENT_SUCCESS = 'FETCH_CLIENT_SUCCESS'
export const FETCH_CLIENT_FAILURE = 'FETCH_CLIENT_FAILURE'

export type Action =
  | { type: 'FETCH_CLIENT_REQUEST' }
  | { type: 'FETCH_CLIENT_PENDING', payload: ?ClientPublic }
  | { type: 'FETCH_CLIENT_SUCCESS', payload: ClientPublic }
  | { type: 'FETCH_CLIENT_FAILURE', payload: Error, error: true }

const ClientRecord = Record({
  loading: false,
  displayName: '',
  learnerForm: List(),
  trial: false,
  totalLearners: null,
  logo: {
    absolute: '',
    absolute150: '',
    relative: '',
  },
  preferences: {
    defaultQuizLevel: '',
    learnerCorrespondence: {
      email: '',
      name: '',
      phone: '',
    },
    learnerRedirectionURL: '',
    digitalLearnerRedirectionURL: ''
  },
  deployment: '',
  quizDisabled: false,
  quizFlags: {
    acsf3shortcourse: true,
    acsf3: true,
    acsf4: true,
    vfh: true,
    dlrq: false
  },
  digitalcourses: [],
  jobs: [],
  digitalProfile: {}
})

/**
 * Handles storing and fetching of client data.
 * @memberof client/reducer
 */
function ClientReducer(
  state: ClientRecord = new ClientRecord(),
  action: Action,
): ClientRecord {
  switch (action.type) {
    case FETCH_CLIENT_REQUEST:
      return state.set('loading', true)

    case FETCH_CLIENT_PENDING:
      if (action.payload != null) {
        return state.set('loading', false).merge(action.payload)
      }
      return state

    case FETCH_CLIENT_SUCCESS:
      return state.set('loading', false)
                  .merge(action.payload)

    case FETCH_CLIENT_FAILURE:
      return state.set('loading', false).set('error', action.payload)

    default:
      return state
  }
}

export default ClientReducer



// WEBPACK FOOTER //
// ./src/state/client/reducer.js